import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, ElementRef, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Project } from '@src/app/models/project';
import { OrgprojectlistService } from './service/orgprojectlist.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { Personproject } from './model/personproject';
import { Person } from './model/person';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Personorg } from './model/personorg';
import { Projectperson } from '@src/app/models/projectperson';
import { Projectmember } from './model/projectmember';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { Orgstyle } from '../../pages/orgaccount/orgstyle/model/orgstyle';
import { ViewportScroller, Location } from '@angular/common';
import { timeout } from 'rxjs/operators';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { PersonOrganization } from '@src/app/models/personorganization';


import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgprojectlist',
  templateUrl: './orgprojectlist.component.html',
  styleUrls: ['./orgprojectlist.component.css'],
  animations: [
    trigger(
      'inbgOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ opacity: 0 }),
            animate('0.2s ease-out',
                    style({ opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ opacity: 1 }),
            animate('0.2s ease-in',
                    style({ opacity: 0 }))
          ]
        )
      ]
    )
  ]
})
export class OrgprojectlistComponent implements OnInit, OnChanges {
  customerChoosen:boolean = false;
  customercount:number;
  targetmodal:string;
  @Input() projecttoadd: Project;
  projectlist:Project[];
  clickedproject:Project;
  memberToAdd:any;
  membersToAdd:Projectmember[];
  @Output() pendingJoinerToAdd:any;
  @Output() pendingJoinerToRemove:any;
  toDelete:Project;
  assignProject:Project;
  iToDelete:number;
  joined:Project[] = [];
  @Output() members:PersonOrganization[];
  projectMembers:Projectperson[];
  assignablePersons:PersonOrganization[];
  myProjects:Projectperson[];
  date0:Date;
  date1:Date;
  noCustomersYet:boolean;
  @Output() orgstyle:Orgstyle;
  setActiveStateProject:Project;
  isFiltered:boolean;
  allProjectsList:Project[];
  filteredProjectList:Project[];
  showProject:string;
  showAssignGuide: string;
  isFilterShown:boolean;
  confirmtagdelete:boolean;
  @ViewChild('closeDisablemodal',{static: true}) closeDisablemodal: ElementRef;

  @ViewChild('closeconfirm',{static:true}) closeconfirm:ElementRef;
  @ViewChildren('projects') private projects: QueryList<ElementRef>;
  showSpinner:boolean;
  timeout: NodeJS.Timeout;

  constructor(
    private tlsrv:OrgprojectlistService,
    private router: Router,
    private route: ActivatedRoute,
    private auth:AuthorizationService,
    private vps:ViewportScroller,
    private location:Location,
    private ref: ChangeDetectorRef,
    private datastore: DatastoreService

  ) { }
  setFilteredList(list:Project[]){
    this.filteredProjectList = list;
    //this.uieventhub.setfilteredProjectList(this.filteredProjectList);
  }
  canEdit(projectId:string){
    return this.auth.isAuthorized('projectedit',projectId)
  }
  canEditOrg(){
    return this.auth.isAuthorized('org_edit',SessionHelper.getChoosenOrg());
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.projecttoadd){
       this.projectlist.push(changes.projecttoadd.currentValue);
       this.sortProjects();
    }

  }
  warnTagDelete(){
    this.confirmtagdelete =! this.confirmtagdelete;
  }
  isFilterShownToggle(){
    this.isFilterShown =! this.isFilterShown;
  }
  toggleActiveFilter(){
    if(this.isFiltered){
      this.projectlist = this.allProjectsList;
      this.isFiltered = false;
    }else{
      this.projectlist = this.projectlist.filter(p => p.isactive == true);
      //console.log('filtered list', this.projectlist);
      this.isFiltered = true;
    }
    
  }
  setActiveState(project:Project){
    if(project.isactive == undefined){
      project.isactive = true;
    }
    this.setActiveStateProject = project;
  }
  disableProject(){

    this.closeDisablemodal.nativeElement.click();
      this.setActiveStateProject.isactive = false;
    this.tlsrv.updateProject(this.setActiveStateProject).pipe(untilDestroyed(this)).subscribe(p =>{
      this.projectlist[this.projectlist.indexOf(this.setActiveStateProject)].isactive = false;
      //console.log(p);
    });
  }
  activateProject(){

    this.closeDisablemodal.nativeElement.click();
    this.setActiveStateProject.isactive = true;
    this.tlsrv.updateProject(this.setActiveStateProject).pipe(untilDestroyed(this)).subscribe(p =>{
      this.projectlist[this.projectlist.indexOf(this.setActiveStateProject)].isactive = true;
      //console.log(p);
    });
  }
  addProjectToList(projectToAdd:Project){

    this.projectlist.splice(0,0,projectToAdd);
    this.ref.markForCheck();
    this.projects.changes.pipe(untilDestroyed(this))
        .subscribe((queryChanges) => {
          this.projects.get(0).nativeElement.click();
        });
    
  }

  ngOnInit() {
    this.showSpinner = true;
    this.showAssignGuide = '';
    this.pendingJoinerToAdd = new Projectperson;
    this.isFiltered = false;
    this.setActiveStateProject = new Project;
    this.orgstyle = new Orgstyle;
    this.orgstyle.sidenav = 'top';
    if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined' ){
      
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    } 
    this.customercount=0;
    this.membersToAdd = [];
    this.date0 = new Date(),
    this.date1 = new Date(),
    this.date1.setDate(this.date0.getDate()+28);
    this.assignProject = new Project;
    this.assignablePersons = [];
    this.myProjects = [];
    this.noCustomersYet = true;
    this.datastore.projectpersonList$.pipe(untilDestroyed(this)).subscribe(pl => {
      this.myProjects = pl;
    });

    this.datastore.orgMembers$.pipe(untilDestroyed(this)).subscribe(mem=> {
      this.members = mem;
    })
    this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(res => {
     this.allProjectsList = res;
     this.projectlist = res;
     this.projectlist.forEach(element => {
      if(element.creator == SessionHelper.getUserSub()) {
        element.canedit = true;
      }else{
        element.canedit = false;
      }
      this.sortProjects();
      if(this.route.snapshot.paramMap.get('projectId'))
      {
        let routeProjectId = this.route.snapshot.paramMap.get('projectId');
        this.showAssignGuide = routeProjectId;
        var proj = this.allProjectsList.find(p => p.projectId == routeProjectId)
         
        
        this.showProject = routeProjectId;
        this.timeout = setTimeout(() => {
          this.setActiveState(proj);
          this.projectClicked(proj);
          this.vps.setOffset([0,130]);
          this.vps.scrollToAnchor('projectdata_'+routeProjectId);
          this.location.replaceState('/projects');
          routeProjectId = '';
        },200);
        
       
        
        

        
       
      }
     });
     this.showSpinner = false;
   })
   this.tlsrv.getCustomers(new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(cus => {
      if (cus.length > 0)
      {
        this.noCustomersYet = false;
      }
         //console.log("list of customers",cus);
      })
  }
  ngAfterContentChecked() {
    this.ref.detectChanges();
  }
  ngOnDestroy(){
    if(this.timeout){
      clearTimeout(this.timeout);
    }
  } 
  sortProjects(){
    this.projectlist = this.projectlist.sort((a,b)=> {
    if(a.created < b.created) { return 1; }
    if(a.created > b.created) { return -1; }
    return 0;
  });
}
  shiftFwd(){
    this.date0.setDate(this.date0.getDate()+7);
    this.date0 = new Date(this.date0);

    this.date1.setDate(this.date1.getDate()+7);
    this.date1 = new Date(this.date1);
  }
  shiftBwd(){
    this.date0.setDate(this.date0.getDate()-7);
    this.date0 = new Date(this.date0);

    this.date1.setDate(this.date1.getDate()-7);
    this.date1 = new Date(this.date1);
  }
  alreadyJoined(project:Project){
    // check if logged in user has joined already

      if(this.myProjects.find(p => p.projectId == project.projectId) != undefined){
        return true;
      }else{
        return false;
      }

  }
  setDelete(project:Project,i:number){
    this.toDelete = project;
    this.iToDelete = i;
  }
  deleteProject(){

    //delete from db
    this.tlsrv.deleteProject(this.toDelete).pipe(untilDestroyed(this)).subscribe(res => {
      //console.log('project deleted', res);
      this.closeconfirm.nativeElement.click();
      //remove from UI
      this.projectlist.splice(this.iToDelete,1);
    });
  }
  setAssignProject(project:Project){
    this.assignablePersons =[];
    this.assignProject = project;
    //Get project members
    this.datastore.projectpersonList$.pipe(untilDestroyed(this)).subscribe(pl => {
      let pml = pl.filter(p => p.projectId == project.projectId);
      this.projectMembers = pml;
      if(this.projectMembers.length == 0){
        this.assignablePersons = this.members;
      }else{
            //Loop all org members and set them assignable if they are not yet in project

      for (let index = 0; index < this.members.length; index++) {
        
        if(this.projectMembers.find(pm => pm.personId === this.members[index].personId)){
          //console.log('Already in project',this.members[index].membername);
        }else{
          this.assignablePersons.push(this.members[index]);

        }


      }
      }
   
    });



  }

  preview(projectId:string){
    this.router.navigate(['organization/'+SessionHelper.getChoosenOrg()+'/organizationproject/'+projectId])
  }
  projectClicked(project:Project){
    this.clickedproject = project;
    this.showProject = project.projectId;
    if(!this.route.snapshot.paramMap.get('projectId')){
      this.showAssignGuide = '';
    }
  }
  joinProject(project:Project){
    if(this.joined.indexOf(project) == -1){
      let sessionPers:Person = JSON.parse(SessionHelper.getPerson());

      let newPersonProject:Personproject = {
        projectId: project.projectId,
        personId: sessionPers.personId,
        fullname: sessionPers.fullname,
        im: sessionPers.im,
        email: sessionPers.email,
        phone: sessionPers.phone,
        title: project.title,
        subtitle: project.subtitle,
        shortdescription: project.shortdescription,
        projectdescription: project.projectdescription,
        projectscope: project.projectscope ? project.projectscope : "organization",
        projectlocation: project.projectlocation,
        start_date: project.start_date,
        end_date: project.end_date,
        organization: SessionHelper.getChoosenOrg(),
        organizationname: project.organizationname,
        customer: project.customer,
        customername: project.customername,
        projectrole: "not set"
      }
      
      this.tlsrv.joinProject(newPersonProject).pipe(untilDestroyed(this)).subscribe(resp =>{
        //console.log(newPersonProject);
        this.pendingJoinerToAdd = newPersonProject;
        this.joined.push(project);
      });
      
    }
  }
  joinerToAdd($event){
    this.memberToAdd = $event;

  }
  assignToProject(){
    // Add to db
    //console.log('assign to project');
    let list = []
    //Add to view
    for (let index = 0; index < this.assignablePersons.length; index++) {
      if(this.assignablePersons[index].assigned){
        let dbadd:Personproject ={
          projectId: this.assignProject.projectId,
          personId: this.assignablePersons[index].personId,
          fullname: this.assignablePersons[index].membername,
          im: this.assignablePersons[index].im,
          email: this.assignablePersons[index].email,
          phone: this.assignablePersons[index].phone,
          title: this.assignProject.title,
          subtitle: this.assignProject.subtitle,
          shortdescription: this.assignProject.shortdescription,
          projectdescription: this.assignProject.projectdescription,
          projectscope: this.assignProject.projectscope,
          projectlocation: this.assignProject.projectlocation,
          start_date: this.assignProject.start_date,
          end_date: this.assignProject.end_date,
          organization: this.assignProject.organizationId,
          organizationname: this.assignProject.organizationname,
          customer: this.assignProject.customer,
          customername: this.assignProject.customername,
          projectrole: this.assignablePersons[index].member_function
        };
        this.tlsrv.assignToProject(dbadd).pipe(untilDestroyed(this)).subscribe(result => {
          //console.log('assign result',result);
        })




        let add:Projectmember = {
          date_added: new Date().toISOString(),
          fullname: this.assignablePersons[index].membername,
          im: this.assignablePersons[index].im,
          email: this.assignablePersons[index].email,
          phone: this.assignablePersons[index].phone,
          personId: this.assignablePersons[index].personId,
          projectId: this.assignProject.projectId,
          projectrole: this.assignablePersons[index].member_function
        }
        list.push(add);

        this.pendingJoinerToRemove = add;
      }



    }
    //console.log('list',list);
    this.membersToAdd = list;
    list = [];
    this.assignablePersons =[];
  }

  choosecustomer(){
    this.customerChoosen = !this.customerChoosen;
  }


}
